import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export const COMMERCIAL_ELIGIBILITY_ENABLED = false;

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet, 
    MatDialogModule,
    MatButtonModule,
    MatIconModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {

  constructor() {}

  protected readonly title = signal('MassEligibility');

  
}
